const Images = {
    Logo: require('../../assets/images/logo-text.png'),
    Avatar: require('../../assets/images/avatar.jpg'),
    LogoSvg: require('../../assets/images/logo.svg'),
};

export default Images;
